export default function ManufacturerMark({ manufacturer, size = "lg" }) {
  const initials = manufacturer.name
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 3)
    .toUpperCase();
  const sizing = size === "sm" ? "h-12 w-12 text-sm" : "h-20 w-20 text-xl";
  return (
    <div
      className={`${sizing} grid shrink-0 place-items-center rounded-2xl border border-neutral-200 bg-neutral-950 font-black tracking-tight text-white shadow-sm`}
      aria-label={`${manufacturer.name} wordmark fallback`}
      title={manufacturer.logoStatus}
    >
      {initials}
    </div>
  );
}
